import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Statistics from './pages/Statistics';
import Goals from './pages/Goals';
import Settings from './pages/Settings';
import Budget from './pages/Budget';
import { TelegramProvider } from './context/TelegramContext';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import Categories from './pages/Categories';

function App() {
  return (
    <TelegramProvider>
      <AuthProvider>
        <CurrencyProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/goals" element={<Goals />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/budget" element={<Budget />} />
            </Routes>
          </Router>
        </CurrencyProvider>
      </AuthProvider>
    </TelegramProvider>
  );
}

export default App;